import { render, staticRenderFns } from "./ChatBase.vue?vue&type=template&id=950bb45a&scoped=true&lang=pug"
import script from "./ChatBase.vue?vue&type=script&lang=js"
export * from "./ChatBase.vue?vue&type=script&lang=js"
import style0 from "./ChatBase.vue?vue&type=style&index=0&id=950bb45a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950bb45a",
  null
  
)

export default component.exports